export const ObjectMetaDataTypeEnum = Object.freeze({
    acreage: 'acreage',
    number: 'number',
    height: 'height'
})